exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-color-cust[data-v-63808815]{background-color:rgba(77,192,181,.129)}", ""]);

// exports
